import produce from 'immer'
import { set, cloneDeep } from 'lodash'

import { FETCH_ACTIVATIONS_SUCCESS } from '../../../../redux/activations/types'
import planTypes from '../../constants/planTypes'
import {
  SET_FIELD_TEXT,
  SET_SELECTED_PLAN,
  RESET_ACTIVATE_ACCOUNT_FORM,
  ACTIVATE_ACCOUNT_SUCCESS,
  SET_ACTIVATE_LOADING_SPINNER,
  SET_CHANGE_CARD_MODE, UPDATE_ACCOUNT_ACTIVATION_SUCCESS, ACTIVATE_INTERNAL_ACCOUNT_SUCCESS
} from '../types'
import { mapActivationDataToActivationState } from './dataMapper'

export interface State {
  selectedPlan: string,
  showValidationErrors: boolean,
  showSuccessPage: boolean,
  isLoading: boolean,
  businessInformation: {
    companyLegalName: string,
    businessRegistrationNumber: string
  },
  businessAddress: {
    addressLine1: string,
    addressLine2: string,
    city: string,
    state: string,
    zipCode: string,
    country: string
  },
  contactInformation: {
    financial: string,
    development: string,
    business: string
  },
  paymentInformation: {
    cardHolderName: string,
    // eslint-disable-next-line camelcase
    last_4_digits: string,
    error: string,
    token: string
  },
  userHasNecessaryRightConfirmation: {
    isChecked: boolean
  },
  isShouldSkipCRMFlow: boolean,
  isChangeCardMode: boolean, // for EDIT viewMode,
  isUpdateSucceeded: boolean
}

export const initialState: State = {
  selectedPlan: planTypes.GROWING,
  showValidationErrors: false,
  showSuccessPage: false,
  isLoading: false,
  businessInformation: {
    companyLegalName: '',
    businessRegistrationNumber: ''
  },
  businessAddress: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
    country: ''
  },
  contactInformation: {
    financial: '',
    development: '',
    business: ''
  },
  paymentInformation: {
    cardHolderName: '',
    // eslint-disable-next-line camelcase
    last_4_digits: '',
    error: '',
    token: ''
  },
  userHasNecessaryRightConfirmation: {
    isChecked: false
  },
  isShouldSkipCRMFlow: false,
  isChangeCardMode: false, // for EDIT viewMode,
  isUpdateSucceeded: false
}

const activationRegistrationUIReducer = produce((state: State, action): State | void => {
  switch (action.type) {
    case SET_FIELD_TEXT:
      return set(state, action.fieldName.split('.'), action.text)
    case SET_SELECTED_PLAN:
      state.selectedPlan = action.selectedPlan
      break
    case RESET_ACTIVATE_ACCOUNT_FORM:
      return initialState
    case ACTIVATE_INTERNAL_ACCOUNT_SUCCESS:
    case ACTIVATE_ACCOUNT_SUCCESS:
      state.showSuccessPage = true
      break
    case SET_ACTIVATE_LOADING_SPINNER:
      state.isLoading = action.isLoading
      break
    case SET_CHANGE_CARD_MODE:
      state.isChangeCardMode = action.isChangeCardMode
      break
    case FETCH_ACTIVATIONS_SUCCESS:
      return mapActivationDataToActivationState(cloneDeep(initialState), action.activation)
    case UPDATE_ACCOUNT_ACTIVATION_SUCCESS:
      state.isUpdateSucceeded = true
      break
  }
}, initialState)

export default activationRegistrationUIReducer
